import {InjectionToken} from "@angular/core";


export const N_TOAST_LANG = new InjectionToken("toastLang");

export interface INToastLang {
  cancelName: string;
  showMoreName: string;
  getHelpName: string;
}

export const DEFAULT_TOAST_LANG: INToastLang = {
  cancelName: "Cancel",
  showMoreName: "Show more",
  getHelpName: "Get help"
};
